var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fill-height":""}},[_c('v-row',{staticClass:"text-center",attrs:{"no-gutters":""}},[_c('v-col',{staticClass:"xs12 sm6 offset-sm3"},[_c('div',{staticClass:"display-4 primary--text"},[_vm._v("404")]),_c('div',{staticClass:"headline"},[_vm._v("Not Found")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }